export default {
    title: "報價車",
    table1: "商品名稱",
    table2: "數量",
    table3: "單位",
    table4: "類型",
    table5: "刪除",
    delAllBtn: "取消報價",
    total1: "共",
    total2: "件商品",
    addCart: "加入購物車",
    errmsg1: "您還未選中商品！",
    errmsg2: "商品中存在非公司商品，請聯繫管理員",
    errmsg3: "您沒有權限報價，請聯繫管理員！",
    succmsg1: "添加報價車訂單成功！",
    succmsg2: "添加購物車成功！",
}